/**
 * transform user received from server
 */
import Moment from 'moment'
import { getRootPluaralTranslator } from '@/src/utils/get-module-translator'
// import { token } from '@utils/auth'
import { buildImageUrlFromRefFileName } from './attachment'
const __rootTc = getRootPluaralTranslator()

export function buildAvatar(user, isRequester) {
  if (!user.name && !user.email) {
    return undefined
  }
  let color = 'ffffff'
  let background = '3279be'
  if (isRequester) {
    color = 'ffffff'
    background = 'f58518'
  }
  if ((user.profilePic || {}).refFileName) {
    return buildImageUrlFromRefFileName(user.profilePic.refFileName)
  }
  const nameString = (user.name || user.email).toUpperCase()
  const matches = nameString.match(/\b(\w)/g) || []
  const name =
    matches.length > 1 ? matches.join('').substr(0, 2) : nameString.substr(0, 2)
  // GET sample avatar url
  return `/api/public/avatar/?size=180&color=${color}&background=${background}&name=${name}`
  // return `https://ui-avatars.com/api/?size=180&color=${color}&background=${background}&name=${(
  //   user.name || user.email
  // ).substr(0, 2)}`
}

export function transformUserNameWithArchiveAndAnonymize(user) {
  const emailOrLogOnName = user.email || user.userLogOnName
  const postFix = () => {
    if (user.anonymizeStatus === 'completed') {
      return `(${__rootTc('anonymized')})`
    } else if (user.removed) {
      return `(${__rootTc('archived')})`
    }
    return ''
  }
  return {
    text: `${
      emailOrLogOnName ? `${user.name} (${emailOrLogOnName})` : user.name
    } ${postFix()}`.trim(),
    nameWithArchive: `${user.name} ${postFix()}`.trim(),
  }
}

export function transformTechnicianPickerOptions(u) {
  return {
    ...transformUserForVuex(u),
    key: u.id,
    id: u.id,
    name: u.name,
    userLogOnName: u.userLogOnName,
    email: u.email,
    avatar: u.avatar,
    requestLoadIndicator: u.loadIndicator || 'low',
    problemLoadIndicator: u.problemLoadIndicator || 'low',
    changeLoadIndicator: u.changeLoadIndicator || 'low',
    releaseLoadIndicator: u.releaseLoadIndicator || 'low',
    groups: u.groups,
    isTenant: u.isTenant,
    archived: u.archived,
    blocked: u.blocked,
    allowToLogin: u.allowToLogin,
    isSuperAdmin: u.isSuperAdmin,
    superAdminRole: u.superAdminRole,
    availabilityStatusId: u.availabilityStatusId,
    thresholdViolated: u.thresholdViolated,
    ...(u.fieldValueDetails || {}),
  }
}

export function transformFieldMappingItems(user) {
  return {
    managerName: user.managerName,
    locationId: user.locationId,
    departmentId: user.departmentId,
    fieldValueDetails: user.fieldValueDetails,
  }
}

export function transformUserForVuex(user) {
  const textArchiveNameProps = transformUserNameWithArchiveAndAnonymize(user)
  const transformedUser = {
    id: user.id,
    name: user.name,
    email: user.email,
    requesterRoles: user.requesterRoles,
    systemUser: user.email === 'system@flotomate.com',
    loginSource: user.loginSource,
    groups: user.groups,
    requesterGroupId: user.requesterGroupId,
    loadIndicator: user.loadIndicator,
    isTenant: user.deleteableOob === false,
    archived: user.removed,
    blocked: user.disabled,
    isSuperAdmin: user.isSuperAdmin,
    allowToLogin: user.allowToLogin,
    cxoUser: user.cxoUser,
    superAdminRole: user.superAdminRole,
    userLogOnName: user.userLogOnName,
    managerId: user.managerId,
    departmentId: user.departmentId,
    department: user.departmentId,
    companyId: user.companyIds,
    locationId: user.locationId,
    location: user.locationId,
    contactNo: user.contactNo,
    altContactNo1: user.altContactNo1,
    altContactNo2: user.altContactNo2,
    blockedReason: user.blockedReason,
    coOpsRole: user.coOpsRole,
    supportLevel: user.supportLevel,
    mfaEnrolled: user.mfaEnrolled,
    enableDndSchedule: user.enableDndSchedule,
    availabilityStatusId: user.availabilityStatusId,
    thresholdViolated: user.thresholdViolated,
    allowDelegateApproval: user.allowDelegateApproval,
    allowWorkDelegationForSelf: user.allowWorkDelegationForSelf,
    allowDelegateApprovalTeam: user.allowDelegateApprovalTeam,
    allowWorkDelegationForTeam: user.allowWorkDelegationForTeam,
    ...(user.dndSchedule
      ? {
          startAt: user.dndSchedule.startAt,
          endAt: user.dndSchedule.endAt,
        }
      : {}),
    ...(user.dateTimeFormat
      ? {
          dateTimeFormat: Moment().toMomentFormatString(user.dateTimeFormat),
        }
      : {}),
    ...(user.dateFormat
      ? {
          dateFormat: Moment().toMomentFormatString(user.dateFormat),
        }
      : {}),
    ...(user.timeFormat
      ? {
          timeFormat: Moment().toMomentFormatString(user.timeFormat),
        }
      : {}),
    ...transformFieldMappingItems(user),
    fieldValueDetails: user.fieldValueDetails || {},
    ...(user.fieldValueDetails || {}),
    requestLoadIndicator: user.loadIndicator || 'low',
    problemLoadIndicator: user.problemLoadIndicator || 'low',
    changeLoadIndicator: user.changeLoadIndicator || 'low',
    releaseLoadIndicator: user.releaseLoadIndicator || 'low',
    ...textArchiveNameProps,
  }
  transformedUser.avatar = buildAvatar(user, user.userType === 'requester')
  return transformedUser
}

export function transformSuperAdminForServer(user) {
  return {
    newUserId: user.newUserId,
    archive: user.archive,
  }
}

export function transformUserForList(user) {
  const textArchiveNameProps = transformUserNameWithArchiveAndAnonymize(user)
  return {
    id: user.id,
    name: user.name,
    avatar: buildAvatar(user, user.userType === 'requester'),
    email: user.email,
    systemUser: user.email === 'system@flotomate.com',
    loginSource: user.loginSource,
    departmentId: user.departmentId,
    department: user.departmentId,
    contactNo: user.contactNo,
    altContactNo1: user.altContactNo1,
    altContactNo2: user.altContactNo2,
    blockedReason: user.blockedReason,
    locationId: user.locationId,
    location: user.locationId,
    verified: user.verified,
    roles: user.roles,
    requesterRoles: user.requesterRoles,
    archived: user.removed,
    canDelete: user.deleteableOob,
    canEdit: user.updatebleOob,
    userType: user.userType,
    userLogOnName: user.userLogOnName,
    ldapUser: user.ldapUser,
    managerId: user.managerId,
    blocked: user.disabled,
    locked: user.locked,
    canSetPassword: user.enableOneTimePasswordForRequester,
    isSuperAdmin: user.isSuperAdmin,
    superAdminRole: user.superAdminRole,
    coOpsRole: user.coOpsRole,
    allowToLogin: user.allowToLogin,
    cxoUser: user.cxoUser,
    vip: user.vip,
    groups: user.groups,
    requesterGroupId: user.requesterGroupId,
    supportLevel: user.supportLevel,
    timezone: user.timezone,
    scope: user.accessLevel,
    assetAccessLevel: user.assetAccessLevel,
    doNotDisturb: user.doNotDisturb,
    companyId: user.companyIds,
    allowDelegateApproval: user.allowDelegateApproval,
    allowDelegateApprovalTeam: user.allowDelegateApprovalTeam,
    allowWorkDelegationForSelf: user.allowWorkDelegationForSelf,
    allowWorkDelegationForTeam: user.allowWorkDelegationForTeam,
    ssoConfigId: user.ssoConfigId,
    availabilityStatusId: user.availabilityStatusId,
    thresholdViolated: user.thresholdViolated,
    fieldValueDetails: user.fieldValueDetails || {},
    licenseType: user.licenseType,
    ...(user.fieldValueDetails || {}),
    ...(user.dateTimeFormat
      ? {
          dateTimeFormat: Moment().toMomentFormatString(user.dateTimeFormat),
        }
      : {}),
    ...(user.dateFormat
      ? {
          dateFormat: Moment().toMomentFormatString(user.dateFormat),
        }
      : {}),
    ...(user.timeFormat
      ? {
          timeFormat: Moment().toMomentFormatString(user.timeFormat),
        }
      : {}),
    ...transformFieldMappingItems(user),
    anonymizeStatus: user.anonymizeStatus,
    customScopeConfigs: user.customScopeConfigs,
    assetCustomScopeConfigs: user.assetCustomScopeConfigs,
    ...textArchiveNameProps,
  }
}

export function transformUser(user, type) {
  const listProps = transformUserForList(user)
  return {
    ...listProps,
    id: user.id,
    name: listProps.nameWithArchive,
    email: user.email,
    ...(user.password ? { password: user.password } : {}),
    systemUser: user.email === 'system@flotomate.com',
    loginSource: user.loginSource,
    timezone: user.timezone,
    signature: user.signature,
    userLogOnName: user.userLogOnName,
    ldapUser: user.ldapUser,
    authenticationSource: user.authenticationSource,
    managerId: user.managerId,
    groups: user.groups,
    groupId: user.groups,
    requesterGroupId: user.requesterGroupId,
    // only for CRUD
    ...(type === 'requester'
      ? {
          groups: user.requesterGroupId,
          groupId: user.requesterGroupId,
        }
      : {}),
    supportLevel: user.supportLevel,
    scope: user.accessLevel,
    accessLevel: user.accessLevel,
    customScopeConfigs: user.customScopeConfigs,
    assetCustomScopeConfigs: user.assetCustomScopeConfigs,
    assetAccessLevel: user.assetAccessLevel,
    profilePic: user.profilePic,
    avatar: buildAvatar(user, user.userType === 'requester'),
    fieldValueDetails: user.fieldValueDetails,
    userType: user.userType,
    vip: user.vip,
    contactNo: user.contactNo,
    altContactNo1: user.altContactNo1,
    altContactNo2: user.altContactNo2,
    blockedReason: user.blockedReason,
    isSuperAdmin: user.isSuperAdmin,
    superAdminRole: user.superAdminRole,
    doNotDisturb: user.doNotDisturb,
    allowToLogin: user.allowToLogin,
    cxoUser: user.cxoUser,
    canDelete: user.deleteableOob,
    verified: user.verified,
    archived: user.removed,
    blocked: user.disabled,
    userLanguage: user.userLanguage,
    delegatorApproval: user.delegatorApproval,
    locked: user.locked,
    canSetPassword: user.EnableOneTimePasswordForRequester,
    coOpsRole: user.coOpsRole,
    ...('companyIds' in user
      ? {
          ...(user.userType === 'requester'
            ? {
                companyId: (user.companyIds || [])[0],
              }
            : {
                companyId: user.companyIds || [],
              }),
        }
      : {}),
    restrictedCompanyAccess: user.restrictedCompanyAccess,
    mfaEnrolled: user.mfaEnrolled,
    allowDelegateApproval: user.allowDelegateApproval,
    allowDelegateApprovalTeam: user.allowDelegateApprovalTeam,
    allowWorkDelegationForSelf: user.allowWorkDelegationForSelf,
    allowWorkDelegationForTeam: user.allowWorkDelegationForTeam,
    ...transformFieldMappingItems(user),
    ssoConfigId: user.ssoConfigId,
    ssoUser: user.ssoUser,
    enableDndSchedule: user.enableDndSchedule,
    ...(user.dndSchedule
      ? {
          startAt: user.dndSchedule.startAt,
          endAt: user.dndSchedule.endAt,
        }
      : {}),
    anonymizeStatus: user.anonymizeStatus,
    consentAcceptedTime: user.consentAcceptedTime,
    licenseType: user.licenseType,
  }
}

export function transformUserForServer(user) {
  const obj = {}
  Object.keys(user).forEach((paramName) => {
    if (/^\d+$/.test(paramName)) {
      if (obj.fieldValueDetails) {
        obj.fieldValueDetails[paramName] = user[paramName]
      } else {
        obj.fieldValueDetails = {
          [paramName]: user[paramName],
        }
      }
    }
  })
  if ('groupId' in user) {
    obj.groups = user.groupId || []
  }
  if ('accessLevel' in user) {
    obj.accessLevel = user.accessLevel
    if (user.accessLevel === 'custom_scope') {
      obj.customScopeConfigs = user.customScopeConfigs
    } else {
      obj.customScopeConfigs = []
    }
  }
  if ('assetAccessLevel' in user) {
    obj.assetAccessLevel = user.assetAccessLevel
    if (user.assetAccessLevel === 'custom_scope') {
      obj.assetCustomScopeConfigs = user.assetCustomScopeConfigs
    } else {
      obj.assetCustomScopeConfigs = []
    }
  }
  if ('locationId' in user) {
    obj.locationId = user.locationId || 0
  }
  if ('departmentId' in user) {
    obj.departmentId = user.departmentId || 0
  }
  return {
    name: user.name,
    email: user.email,
    loginSource: user.loginSource,
    ...(user.password ? { password: user.password } : {}),
    ...(user.userType ? { userType: user.userType } : {}),
    ...(user.oneTimePassword ? { oneTimePassword: user.oneTimePassword } : {}),
    timezone: user.timezone,
    locationId: user.location,
    signature: user.signature ? user.signature : null,
    departmentId: user.department,
    groups: user.groups,
    supportLevel: user.supportLevel,
    roles: user.roles,
    requesterRoles: user.requesterRoles,
    accessLevel: user.scope,
    assetAccessLevel: user.assetAccessLevel,
    profilePic: user.profilePic,
    vip: user.vip,
    verified: user.verified,
    fieldValueDetails: user.fieldValueDetails,
    contactNo: user.contactNo,
    altContactNo1: user.altContactNo1,
    altContactNo2: user.altContactNo2,
    blockedReason: user.blockedReason,
    isSuperAdmin: user.isSuperAdmin,
    superAdminRole: user.superAdminRole,
    doNotDisturb: user.doNotDisturb,
    allowToLogin: user.allowToLogin,
    userLogOnName: user.userLogOnName,
    ldapUser: user.ldapUser,
    authenticationSource: user.authenticationSource,
    managerId: user.managerId,
    disabled: user.blocked,
    userLanguage: user.userLanguage,
    ...('companyId' in user
      ? {
          ...(user.userType === 'requester'
            ? {
                companyIds:
                  user.companyId && user.companyId ? [user.companyId] : [],
              }
            : { companyIds: user.companyId }),
        }
      : {}),
    restrictedCompanyAccess: user.restrictedCompanyAccess,
    allowDelegateApproval: user.allowDelegateApproval,
    allowDelegateApprovalTeam: user.allowDelegateApprovalTeam,
    allowWorkDelegationForSelf: user.allowWorkDelegationForSelf,
    allowWorkDelegationForTeam: user.allowWorkDelegationForTeam,
    ssoConfigId: user.ssoConfigId,
    enableDndSchedule: user.enableDndSchedule,
    licenseType: user.licenseType,
    ...(user.enableDndSchedule
      ? {
          dndSchedule: {
            type: 'FlotoTimeSpanScheduleRest',
            startAt: user.startAt,
            endAt: user.endAt,
          },
        }
      : {}),
    ...(user.dateTimeFormat
      ? {
          dateTimeFormat: Moment().toJDFString(user.dateTimeFormat),
        }
      : {}),
    ...(user.dateFormat
      ? {
          dateFormat: Moment().toJDFString(user.dateFormat),
        }
      : {}),
    ...(user.timeFormat
      ? {
          timeFormat: Moment().toJDFString(user.timeFormat),
        }
      : {}),
    ...obj,
    consentAcceptedTime: user.consentAcceptedTime,
  }
}

export function transformUserSessions(user) {
  return {
    id: user.id,
    email: user.email,
    name: user.name,
    logonName: user.logonName,
    userId: user.userId,
  }
}
